import React from "react";

export default function Plate({ value, small }) {
  return (
    <span className={`plate ${small ? "plate-sm" : ""}`} data-testid="plate-display">
      {value || "—"}
    </span>
  );
}
